<template>
  <div id="body">
    <main id="printable-page" class="page__size">
      <!-- Header -->
      <div class="header">
        <div class="header__logo">
          <img :src="'configData.company_logo'" class="res__img" alt="" />
        </div>
        <div class="invoice__right">
          <h2 class="invoice__hero-title">Invoice</h2>
        </div>
      </div>

      <!-- body -->
      <div class="content__body">
        <!-- invoice header -->
        <div class="invoice__header">
          <div class="invoice__number">
            <span>Invoice No</span>

            <p class="invoice-text">TI-{{ String(formData.invoice_number).padStart(6, '0') }}</p>
          </div>
          <div class="invoice__date">
            <span>Date</span>
            <p class="invoice-text">{{ formatDateToLocal(formData.date) }}</p>
          </div>

          <div v-if="formData && formData.client" class="invoice__date">
            <span>To</span>
            <p class="invoice-text mb-0">{{ formData.client.full_name }}</p>
            <template v-if="formData.client.profile">
              <small v-if="formData.client.profile.contact">{{ $t("contact") }}:
                {{ formData.client.profile.contact }}</small>
              <br />
              <small v-if="formData.client.profile.address">{{ $t("address") }}:
                {{ formData.client.profile.address }}</small><br />

            </template>
          </div>
        </div>

        <div class="invoice__payment-info">
          <div class="invoice__price-total">
            <p class="price__title">{{ $t("due_amount") }} :</p>
            <h3 class="price">
              {{ numberWithCurrencySymbol(formData.due_amount) }}
            </h3>
          </div>

          <div class="invoice__price-total invoice-payment">
            <p class="price__title">{{ $t("paid") }} :</p>
            <h3 class="price label-success">
              {{ numberWithCurrencySymbol(formData.received_amount) }}
            </h3>
          </div>

          <ul class="invoice__c-address" style="max-width: 40%"></ul>
        </div>

        <!-- product description -->
        <div class="invoice__product-info">
          <table class="table" border="0">


            <thead>
              <tr class="bg-dark text-light">
                <th class="w-45 p-1 text-left">
                  <h5 class="table-title">Product</h5>
                </th>
                <th class="w-10 p-1 text-right">
                  <h5 class="table-title">Qty</h5>
                </th>
                <th class="w-20 p-1 text-right">
                  <h5 class="table-title">Unit Price</h5>
                </th>
                <th class="w-5 p-1 text-right">
                  <h5 class="table-title">Tax</h5>
                </th>
                <th class="w-20 p-1 text-right">
                  <h5 class="table-title">Total</h5>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(invoiceProduct, index) in formData.invoice_details" :key="`invoice-item-${index}`">
                <td>
                  <div class="product__item-info">
                    <h5 class="title">{{ invoiceProduct.details }}</h5>
                  </div>
                </td>

                <td>
                  <p class="price">
                    {{ invoiceProduct.quantity }}
                  </p>
                </td>

                <td>
                  <p class="price">
                    {{ numberWithCurrencySymbol(invoiceProduct.price) }}
                  </p>
                </td>

                <td>
                  <p class="price">N/A</p>
                </td>

                <td>
                  <p class="price">
                    {{
                    numberWithCurrencySymbol(
                    calculateProductTax(
                    invoiceProduct.tax ? invoiceProduct.tax.value : 0,
                    invoiceProduct.quantity * invoiceProduct.price
                    ) +
                    invoiceProduct.quantity * invoiceProduct.price
                    )
                    }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- payment total -->
        <div class="invoice__total-payment">
          <div class="payment__method">
            <h4 class="title">Payment Method</h4>
            <table>
              <tr>
                <td>
                  <span class="left-icon">
                    <img src="/images/invoice/cash.svg" alt="" />
                  </span>
                </td>
                <td>
                  <span class="payment_title">Cash Payment</span>
                </td>
              </tr>

              <tr>
                <td>
                  <span class="left-icon">
                    <img src="/images/invoice/mobile-banking.svg" alt="" />
                  </span>
                </td>
                <td>
                  <span class="payment_title">Bkash/Nagad </span>
                  <span class="right-icon">
                    <img src="/images/invoice/bkash.png" alt="" /></span>
                  <span class="right-icon">
                    <img src="/images/invoice/nagad.png" alt="" /></span>
                  <br />
                  01855367818(Personal)
                </td>
              </tr>

              <tr>
                <td>
                  <span class="left-icon">
                    <img src="/images/invoice/cash.svg" alt="" />
                  </span>
                </td>
                <td>
                  <span class="payment_title"> Bank (United Commercial Bank) </span>
                  <br />
                  Name : The Tork Incorporation
                  <br />
                  Account No : 1602 1010 0000 7803
                  <br />
                  Branch : Khilgaon Branch
                </td>
              </tr>
            </table>
          </div>
          <div class="sub__total">
            <ul class="hidden">
              <li>
                <span class="title">Subtotal:</span>
                <span class="price sub-price">৳25,000.00</span>
              </li>
            </ul>

            <ul class="hidden">
              <li>
                <span class="title">Discount(Fixed):</span>
                <span class="price sub-price">৳0.00</span>
              </li>

              <li class="hidden">
                <span class="title">Total(Before Tax):</span>
                <span class="price sub-price">৳25,000.00</span>
              </li>
            </ul>

            <ul class="hidden">
              <li class="hidden">
                <span class="title">:</span>
                <span class="price sub-price">৳0.00</span>
              </li>
            </ul>

            <div class="grand__total">
              <div>Grand Total:</div>
              <div>{{ numberWithCurrencySymbol(formData.total) }}</div>
            </div>
          </div>
        </div>

        <div class="sincearly">
          <div class="signature">
            <img src="/images/invoice/signature.png" class="res__img" alt="" srcset="" />
          </div>
          <p class="designation">Authorized Sign</p>
        </div>

        <div class="bottom-text">
          Please pay your invoice by
          <b>{{ formatDateToLocal(formData.due_date) }}</b>
          <br />
        </div>
      </div>

      <!-- footer -->
      <div class="footer">
        <div class="">
          <div class="company__info">
            <div class="row">
              <div class="col">
                <div class="address__content">
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-telephone" viewBox="0 0 16 16">
                      <path
                        d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z" />
                    </svg>
                  </span>
                  <div class="info">
                    <p>+880-130 2537 376</p>
                    <p>+880-185 5367 818</p>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="address__content">
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-envelope" viewBox="0 0 16 16">
                      <path
                        d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2zm13 2.383-4.758 2.855L15 11.114v-5.73zm-.034 6.878L9.271 8.82 8 9.583 6.728 8.82l-5.694 3.44A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.739zM1 11.114l4.758-2.876L1 5.383v5.73z" />
                    </svg>
                  </span>
                  <div class="info">
                    <p>mail@thetork.com</p>
                    <p>cto.tork@gmail.com</p>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="address__content">
                  <span class="icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-geo-alt" viewBox="0 0 16 16">
                      <path
                        d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A31.493 31.493 0 0 1 8 14.58a31.481 31.481 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94zM8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10z" />
                      <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4zm0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6z" />
                    </svg>
                  </span>
                  <div class="info">
                    <p>
                      House# 19, Road# 03, Block# G, Rampura Banasree, Dhaka-
                      1219
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <div class="watermark">


        <!--unpaid-->

        <!-- @if($invoice->status->name == 'status_unpaid') -->
        <!-- <span class="js-invoice-statuses" id="invoice-status-due">
                  <h1 class="text-uppercase text-danger">Unpaid</h1>
              </span> -->
        <!-- @endif -->

        <!-- @if($invoice->status->name == 'status_partially_paid') -->
        <!--overdue-->
        <!-- <span class="js-invoice-statuses" id="invoice-status-partially-paid">
                  <h1 class="text-uppercase text-warning">Partially Paid</h1>
              </span> -->

        <!-- @endif -->

        <!-- @if($invoice->status->name == 'status_overdue') -->

        <!--overdue-->
        <!-- <span class="js-invoice-statuses" id="invoice-status-partially-paid">
                  <h1 class="text-uppercase text-danger">Overdue</h1>
              </span> -->

        <!-- @endif -->

        <!--paid-->

        <!-- @if($invoice->status->name == 'status_paid') -->

        <!-- <span class="js-invoice-statuses" id="invoice-status-paid">
                  <h1 class="text-uppercase text-success">Paid</h1>
              </span> -->

        <!-- @endif -->
      </div>


    </main>
  </div>
</template>

<script>
import AppFunction from "../../../../core/helpers/app/AppFunction";
import { SubmitFormMixins } from "../../../Mixins/billar/SubmitFormMixins";
import {
  formatDateToLocal,
  numberWithCurrencySymbol,
} from "../../../Helpers/Helpers";

export default {
  name: "InvoiceDetails",
  mixins: [SubmitFormMixins],
  props: {
    configData: {},
  },
  data() {
    return {
      numberWithCurrencySymbol,
      formatDateToLocal,
      dataLoaded: false,
      AppFunction,
      isSendInvoiceModalActive: false,
      isInvoiceAddEditModalActive: false,
      productList: [],
      selectUrl: "",
      formData: {},
    };
  },
  computed: {
    totalTax() {
      let totalTaxes = 0;
      this.formData.invoice_details.map((item) => {
        if (item.tax) {
          totalTaxes =
            totalTaxes + (item.price * item.quantity * item.tax.value) / 100;
        } else {
          totalTaxes = totalTaxes + 0;
        }
      });
      return totalTaxes;
    },
  },
  methods: {
    calculateProductTax(tax, totalPrice) {
      let taxes = 0;
      taxes = (totalPrice * tax) / 100;
      return taxes;
    },
    afterSuccessFromGetEditData(response) {
      this.formData = response.data;
      this.dataLoaded = true;
    },
    downloadInvoice() {
      window.open(
        AppFunction.getAppUrl(`invoice-download/${this.formData.id}`)
      );
    },
    openSendInvoiceModal() {
      this.isSendInvoiceModalActive = true;
    },
    closeSendInvoiceModal() {
      this.isSendInvoiceModalActive = false;
      $("#send-invoice-modal").modal("hide");
    },
    printDiv() {
      const divToPrint = document.getElementById("printable-page");
      console.log(divToPrint);
      const printContents = divToPrint.innerHTML;
      const originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
    },
  },
};
</script>
<style scoped>
@page {
  size: A4;
  margin: 0;
}

body {
  font-family: "Poppins", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 25px;
}

ul {
  list-style: none;
}

.row {
  display: flex;
  flex-wrap: wrap;
}

.col {
  flex: 1 0 0%;
  padding-right: 0;
  padding-left: 0;
}

.res__img {
  max-width: 100%;
  height: auto;
}

.container {
  margin-left: 80px;
  margin-right: 80px;
}

.pt60 {
  padding-top: 60px;
}

.pb60 {
  padding-bottom: 60px;
}

.page__size {
  width: 210mm;
  height: 297mm;
  background-color: #ffffff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  margin: 0 auto;
  padding: 80px;
  position: relative;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header__logo {
  width: 150px;
}

.content__body {
  height: calc(100% - 366px);
}

.invoice__hero-title {
  font-size: 40px;
  font-weight: 700;
  text-transform: uppercase;
  background: linear-gradient(to right, #614bfd 0%, #1faefe 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  line-height: 1.4;
}

.invoice__header {
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  border-top: 1px solid #c4c4c4;
  margin-top: 15px;
}

.invoice-text {
  font-weight: 600;
}

.invoice__customer-info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.title {
  padding-right: 10px;
}

.customer {
  padding-left: 10px;
  border-left: 1px solid #c4c4c4;
}

.invoice__payment-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border-top: 1px solid #c4c4c4;
}

.price__title {
  font-size: 18px;
  text-transform: uppercase;
  margin-bottom: 5px;
}

.invoice__price-total.invoice-payment {
  border-left: 1px solid #c4c4c4;
  padding-left: 20px;
}

.invoice__c-address {
  border-left: 1px solid #c4c4c4;
  padding-left: 20px;
  max-width: 50%;
}

.invoice__payment-info .price {
  font-size: 28px;
  font-weight: 600;
  margin-top: 10px;
  line-height: 25px;
  text-transform: uppercase;
}

.invoice__c-address li {
  margin-top: 4px;
  display: inline-flex;
  width: 100%;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table thead th {
  padding: 10px 20px!important;
  text-align: left!important;
}

.table tbody tr {
  background-color: #e7e7e7;
}

.table tbody td {
  padding: 10px 20px;
}
p{
  margin-bottom: 0px!important;
}

.table tbody tr:nth-child(even) {
  background-color: #f5f5f5;
}

.table .title {
  font-size: 14px;
  font-weight: 600;
  text-transform: capitalize;
  margin-bottom: 2px;
}

.table .price {
  font-weight: 600;
}

.table-title {
  font-weight: 600;
  color: #ffffff;
  font-size: 14px;
  text-transform: capitalize;
}

.table thead tr {
  background: url("/images/invoice/letter-head-bottom.png");
  background-size: cover;
  background-repeat: no-repeat;
}

.invoice__total-payment {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 30px;
}

.grand__total {
  padding: 10px 20px;
  background: url("/images/invoice/letter-head-bottom.png");
  background-size: cover;
  background-repeat: no-repeat;
  color: #ffffff;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
}

.sub__total {
  width: 45%;
  font-size: 16px;
  text-transform: capitalize;
}

.sub__total ul {
  padding: 0 20px;
}

.sub__total li {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sub__total .title {
  font-weight: 600;
  text-transform: capitalize;
}

.sincearly {
  position: absolute;
  right: 60px;
  bottom: 100px;
  width: 200px;
  text-align: center;
}

.signature {
  margin-top: 25px;
  margin: 0 auto;
}

.signature img {
  height: 72px;
  width: auto;
}

.sub-price {
  font-weight: 600;
}

.bottom-text {
  position: absolute;
  left: 80px;
  bottom: 110px;
}

/* Footer */
.footer {
  background: url("/images/invoice/letter-head-bottom.png");
  background-size: cover;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: #ffffff;
  padding: 15px 60px;
  border-radius: 30px 30px 0px 0px;
  padding-top: 20px;
}

.footer__logo {
  width: 100px;
  text-align: right;
  margin-left: auto;
}

.address__content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.company__info {
  width: 100%;
}

.company__info p {
  margin-bottom: 0;
  line-height: 20px;
  font-size: 12px;
}

.icon {
  margin-right: 10px;
  margin-top: 4px;
}

/* 
        .icon svg {
            fill: #ffffff;
        } */

.payment__method .title {
  margin-bottom: 20px!important;
  font-size: 14px;
  font-weight: 700;
}

.payment__method td {
  vertical-align: top;
  padding: 5px;
}

.payment__method .payment_title {
  font-weight: 600;
  margin-right: 10px;
}

.payment__method .left-icon img {
  height: 30px;
  width: 30px;
  position: relative;
  background: linear-gradient(to right, #614bfd50 0%, #1faefe50 100%);
  padding: 5px;
  border-radius: 50%;
}

.payment__method .right-icon {
  margin-left: 5px;
}

.payment__method .right-icon img {
  height: 12px;
  width: auto;
  position: relative;
  border-radius: 2px;
}

.hidden {
  display: none !important;
}

.download-button {
  position: fixed;
  top: 75px;
  right: 25px;
}

.download-button button {
  padding: 10px 20px;
  border-radius: 20px;
  font-family: "Poppins";
  font-weight: 700;
  color: #ffffff;
  background: linear-gradient(to right, #614bfd 0%, #1faefe 100%);
  border: 0px;
  cursor: pointer;
}

.watermark {
  position: absolute;
  top: 53%;
  transform: translate(-50%, -50%) rotate(-45deg);
  left: 50%;
}

.watermark h1 {
  color: #67757c;
  font-family: "Poppins";
  font-size: 3rem;
  opacity: 0.3;
}

.text-success {
  color: #24d2b5 !important;
}

.text-danger {
  color: #ff5c6c !important;
}

.text-default {
  color: #67757c !important;
}

.text-warning {
  color: #ff9041 !important;
}

.text-info {
  color: #17a2b8 !important;
}

@media print {
  .download-button {
    display: none;
  }
  #printable-page {
    height: 100% !important;
    width: 100% !important;
    padding: 80px;
  }
}

 .w-45 {
            width: 45%;
        }
        .w-20 {
            width: 20%;
        }
        .w-15 {
            width: 10%;
        }
        .w-10 {
            width: 10%;
        }
        .w-5 {
            width: 5%;
        }

        h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6{
          margin-bottom: 0px!important;
        }
</style>
